<template>
  <div id="invoice-page">
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
                class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Order detail</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false"
                      class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
        <div class="p-6">
          <vs-button @click="printGo(order)" class="mb-5" style="width: 100%">Print</vs-button>
          <!--Delivery Date-->
          <div>
            <label class="vs-select--label" for="deliveryDate">Delivery date*</label>
            <datepicker label="Delivery date" v-model="order.deliveryDate"
                        id="deliveryDate" v-validate="'required'"></datepicker>
            <span class="text-danger text-sm"
                  v-show="errors.has('deliveryDate')">{{ errors.first('deliveryDate') }}</span>
          </div>
          <!--End-->
          <!--Observation-->
          <vs-input name="observation" label="Comments"
                    v-model="order.observation"
                    class="mt-5 w-full"/>
          <span class="text-danger text-sm"
                v-show="errors.has('observation')">{{ errors.first('observation') }}</span>
          <!--List products-->
          <hr class="mt-5 mb-5">
          <div>
            <vs-table class="mt-5" :data="order.products">
              <template slot="thead">
                <vs-th>Name</vs-th>
                <vs-th>Presentation</vs-th>
                <vs-th>Price</vs-th>
                <vs-th>Quantity</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="tr.name">
                    {{ tr.name }}
                  </vs-td>

                  <vs-td :data="tr.feature">
                    {{ tr.feature ? tr.feature.value : 'Box' }}
                  </vs-td>

                  <vs-td :data="tr.price">
                    $ {{ tr.price | round }}
                  </vs-td>

                  <vs-td :data="tr.quantity">
                    <template>
                      <vs-input-number v-model="tr.quantity"/>
                    </template>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!--Total-->
            <div class="mt-5"
                 style="display: flex; justify-content: space-between; font-size: 1.2rem; font-weight: 600">
              <span>Total</span>
              <span>$ {{ order.total | round }}</span>
            </div>
          </div>
          <hr class="mt-5 mb-5">
          <!--End-->
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button v-if="order.products.length>0" class="mr-6" @click="submitData">
          Update
        </vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Close</vs-button>
        <div v-if="progress" style="margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import StatisticsCardLine from "../../components/statistics-cards/StatisticsCardLine";
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import print from "print-js"
import {en} from 'vuejs-datepicker/dist/locale';

Datepicker.props.language.default = () => en;

const firebase = require("firebase")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    StatisticsCardLine,
    Datepicker
  },
  data() {
    return {
      order: {
        total: 0,
        products: []
      },
      newProduct: {
        id: null,
        name: null,
        price: null,
        quantity: 0
      },
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      states: [
        {text: 'On hold', value: 'onHold'},
        {text: 'Accepted', value: 'success'},
        {text: 'Rejected', value: 'rejected'},
        {text: 'Delivered', value: 'delivered'}
      ]
    }
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        if (val) {
          this.order = {
            ...this.data
          }
        }
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.newProduct.id && this.newProduct.quantity > 0
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    initValues() {
      this.order = {
        products: []
      }
    },
    async submitData() {
      try {
        this.progress = true
        const orderRef = db.collection('orders').doc(this.order.id)
        this.order.total = await this.calculateTotal()
        const obj = {...this.order}
        delete obj.id
        delete obj.createdAt
        delete obj.uid
        await orderRef.update({
          ...obj
        })
        await this.$store.dispatch('orders/updateOrder', {order: this.order})
        this.progress = false
        this.$vs.notify({
          color: 'success',
          title: 'Order',
          text: 'Order updated successfully.'
        })
        this.isSidebarActiveLocal = false
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      } finally {
        this.progress = false
      }
    },
    printGo(order) {
      let products = []
      order.products.forEach((p) => {
        let product = {
          name: p.labelName,
          feature: p.feature ? p.feature.value : 'Box',
          price: "$ " + parseFloat(p.price).toFixed(2),
          quantity: p.quantity
        }
        products.push(product)
      })

      print({
        printable: products,
        type: 'json',
        properties: [
          {field: 'name', displayName: 'Name'},
          {field: 'feature', displayName: 'Presentation'},
          {field: 'price', displayName: 'Price'},
          {field: 'quantity', displayName: 'Quantity'},
        ],
        header: `<h3 class="custom-h3">${order.id.substr(0, 6).toUpperCase()}<br>Total: $ ${order.total} </h3><br> <h3>${order.client.location} <br> ${order.client.displayName} <br> ${this.$options.filters.date(order.createdAt)} <br>${this.$options.filters.time(order.createdAt, true)} <h3>`
      })
    },
    calculateTotal() {
      return new Promise((resolve, reject) => {
        let total = 0
        this.order.products.forEach((p) => {
          total += (p.price * p.quantity)
        })
        if (total === 0 || total < 0) {
          reject(new Error("Subtotal 0"))
        }
        resolve(parseFloat(total.toFixed(2)))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 900px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
